export function beautifyUrl(url: string): string {
  return url.replace(/([^:]\/)\/+/g, '$1');
}
